import Marks from "./Gifs/mark-management.gif";
import Stickies from "./Gifs/stickies++.gif";
import Preesh from "./Gifs/preesh.gif";
import Battleship from "./Gifs/battleship.gif";
import EuropeTourism from "./Gifs/europeTourism.gif";
import AIAssistant from "./Gifs/clinician_portal.gif"
import MarketResearcher from "./Gifs/market-researcher.gif"

export const cardContents = [
	{
		header: AIAssistant,
		title: "Ava The AI Assistant",
		details: "Application which uses AI to improve triage prioritization and patient diagnosis",
		demo_link: "https://www.loom.com/share/98ccb003beda461195ec8fcfe9bbb045?sid=d64a05a3-b152-4452-9e0a-7f3185726d22",
		source: "https://github.com/noahnefsky/ai_patient_diagnosis",
	},
	{
		header: MarketResearcher,
		title: "Market Research Agent",
		details: "Built a market research agent that delivers structured financial insights for portfolio decisions, saving hours each week",
		source: "https://github.com/tavily-ai/market-researcher"
	},
	{
		header: Preesh,
		title: "Preesh Rewards",
		details: "Single handedly built a mobile rewards application for tracking and utilizing points earned",
		source: "https://github.com/noahnefsky/Preesh-Rewards",
	},
	{
		header: Stickies,
		title: "Stickies++",
		details: "Developed a notes application to maximize customization and note-taking efficiency",
		source: "https://github.com/noahnefsky/Note-Taking-App",
	},
	{
		header: EuropeTourism,
		title: "Visualizing Europe Tourism",
		details: "Created an interactive data map with a slider and a star plot to visualize monthly tourist activity",
		source: "https://github.com/noahnefsky/EuropeTourism",
	},
	{
		header: Battleship,
		title: "Battleship",
		details: "Created a UI for the game Battleship.",
		source: "https://github.com/noahnefsky/Battleship"
	},
	{
		header: Marks,
		title: "Mark Management Application",
		details: "Built program loading, process synchronization and a file management system into an operating system",
		source: "https://github.com/noahnefsky/Mark-Management-App",
	},
];
export default cardContents;